import React from "react";
import { useStatusBar } from "@/contexts/StatusBarContext";
import { LinearProgress, Typography, IconButton, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { isInIframe } from "@/services/iframe.service";

const StatusBar: React.FC = () => {
  const { tasks, removeTask } = useStatusBar();

  if (tasks.length === 0) return null; // Ne pas afficher la barre si aucune tâche en cours
  return (
    <Alert
      variant="filled"
      severity="info"
      sx={{
        position: "fixed",
        top: isInIframe() ? 16 : 66,
        right: 16,
        width: 250,
        padding: 1,
        borderRadius: 2,
        overflow: "hidden", // Prevent scrollbars
        whiteSpace: "normal", // Allow wrapping of long text
        wordBreak: "break-word", // Break long words if needed
      }}
    >
      {tasks.map((task) => (
        <div key={task.id} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="caption" sx={{ flex: 1, fontSize: "0.75rem" }}>
              {task.message}
            </Typography>
            <IconButton size="small" color="inherit" onClick={() => removeTask(task.id)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>
          {task.progress !== undefined && (
            <LinearProgress
              variant={task.progress === "indeterminate" ? "indeterminate" : "determinate"}
              value={task.progress === "indeterminate" ? undefined : task.progress}
              sx={{ height: 4, borderRadius: 2, width: "100%" }}
            />
          )}
        </div>
      ))}
    </Alert>
  );
};

export default StatusBar;
